export default function () {
  return [
    // Dashboard
    {
      title: 'Painel de controle',
      name: 'dashboard',
      to: {
        name: 'admin-overview',
      },
      htmlBefore: '<i class="material-icons">dashboard</i>',
    },
    // Product
    {
      title: 'Produtos',
      name: 'products',
      isCustomer: false,
      htmlBefore: '<i class="material-icons">local_mall</i>',
      to: {
        name: 'admin-product-list',
        params: {
          page: 1,
        },
      },
      items: [
        {
          title: 'Produto',
          to: {
            name: 'admin-product-list',
            params: {
              page: 1,
            },
          },
        },
        {
          title: 'Material',
          to: {
            name: 'admin-material-list',
            params: {
              page: 1,
            },
          },
        },
        {
          title: 'Service',
          to: {
            name: 'admin-service-list',
            params: {
              page: 1,
            },
          },
        },
        {
          title: 'Atualizar Preços',
          to: {
            name: 'admin-product-update-price',
            params: {
              page: 1,
            },
          },
        },
      ],
    },
    // Customer
    {
      title: 'Clientes',
      name: 'customers',
      isCustomer: false,
      htmlBefore: '<i class="material-icons">person</i>',
      to: {
        name: 'admin-customer-list',
        params: {
          page: 1,
        },
      },
      items: [
        {
          title: 'Lista',
          to: {
            name: 'admin-customer-list',
            params: {
              page: 1,
            },
          },
        },
        {
          title: 'Adicionar',
          href: '/admin/clientes/novo',
          to: {
            name: 'admin-customer-new',
          },
        },
      ],
    },
    // Project
    {
      title: 'Obras',
      name: 'projects',
      htmlBefore: '<i class="material-icons">table_chart</i>',
      to: {
        name: 'admin-project-list',
        params: {
          page: 1,
        },
      },
      items: [
        {
          title: 'Lista',
          to: {
            name: 'admin-project-list',
            params: {
              page: 1,
            },
          },
        },
        {
          isCustomer: false,
          title: 'Adicionar',
          href: '/admin/obras/novo',
          to: {
            name: 'admin-project-new',
          },
        },
        {
          isCustomer: false,
          title: 'Status',
          to: {
            name: 'admin-status-list',
            params: {
              page: 1,
            },
          },
        },
      ],
    },
    // Quotation
    {
      title: 'Orçamentos',
      name: 'quotations',
      htmlBefore: '<i class="material-icons">note_add</i>',
      to: {
        name: 'admin-quotation-list',
        params: {
          page: 1,
        },
      },
      items: [
        {
          title: 'Lista',
          to: {
            name: 'admin-quotation-list',
            params: {
              page: 1,
            },
          },
        },
        {
          isCustomer: false,
          title: 'Adicionar',
          to: {
            name: 'admin-quotation-customer',
            params: {
              quotationId: 'novo',
            },
          },
        },
        // {
        //   isAdmin: true,
        //   title: 'Lista de modelos',
        //   to: {
        //     name: 'admin-quotation-model-list',
        //     params: {
        //       page: 1,
        //     },
        //   },
        // },
        // {
        //   isAdmin: true,
        //   title: 'Novo Modelo',
        //   href: '/admin/orcamentos/modelo/novo',
        //   to: {
        //     name: 'admin-quotation-model-new',
        //   },
        // },
        {
          isAdmin: true,
          title: 'Lista de Templates',
          to: {
            name: 'admin-quotation-template-list',
            params: {
              page: 1,
            },
          },
        },
      ],
    },
    // Report
    {
      title: 'Relatórios',
      name: 'reports',
      htmlBefore: '<i class="material-icons">list_alt</i>',
      isAdmin: true,
      to: {
        name: 'admin-report-list',
        params: {
          page: 1,
        },
      },
      items: [
        {
          title: 'Produtos',
          to: {
            name: 'admin-report-list',
            params: {
              page: 1,
            },
          },
        },
        {
          title: 'Vendedor',
          to: {
            name: 'admin-report-seller-list',
            params: {
              page: 1,
            },
          },
        },
        {
          title: 'Orçamentos',
          to: {
            name: 'admin-report-quotation-list',
            params: {
              page: 1,
            },
          },
        },
        {
          title: 'Segmentos',
          to: {
            name: 'admin-report-drive-list',
            params: {
              page: 1,
            },
          },
        },
      ],
    },
    // Ticket
    {
      title: 'Chamados',
      name: 'tickets',
      to: {
        name: 'admin-ticket-list',
        params: {
          page: 1,
        },
      },
      htmlBefore: '<i class="material-icons">vertical_split</i>',
      items: [
        {
          title: 'Lista',
          to: {
            name: 'admin-ticket-list',
            params: {
              page: 1,
            },
          },
        },
        {
          title: 'Adicionar',
          to: {
            name: 'admin-ticket-new',
          },
        },
      ],
    },
    // Rating
    {
      title: 'Avaliação',
      name: 'ratings',
      to: {
        name: 'admin-rating-answers-projects',
        params: {
          page: 1,
        },
      },
      htmlBefore: '<i class="material-icons">grade</i>',
      items: [
        {
          title: 'Respostas das obras',
          to: {
            name: 'admin-rating-answers-projects',
            params: {
              page: 1,
            },
          },
        },
        {
          title: 'Respostas dos chamados',
          to: {
            name: 'admin-rating-answers-tickets',
            params: {
              page: 1,
            },
          },
        },
        {
          isCustomer: false,
          title: 'Questões',
          to: {
            name: 'admin-rating-list',
          },
        },
      ],
    },
    // User
    {
      isCustomer: false,
      title: 'Usuários',
      name: 'users',
      to: {
        name: 'admin-user-list',
        params: {
          page: 1,
        },
      },
      htmlBefore: '<i class="material-icons">perm_identity</i>',
      items: [
        {
          title: 'Lista',
          to: {
            name: 'admin-user-list',
            params: {
              page: 1,
            },
          },
        },
        {
          title: 'Adicionar',
          to: {
            name: 'admin-user-new',
          },
        },
      ],
    },
  ];
}
